<template>
  <v-data-table
    :headers="headers"
    :items-per-page="10"
    :items="items"
    disable-sort
    hide-default-footer
    class="elevation-1">
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | localDate() }}
    </template>
    <template v-slot:[`item.reference`]="{ item }">
      <p>Ref : <b>{{ item.reference }}</b></p>
      <p>updateBy : {{ item.createdBy.email }}</p>
      <p>Note : {{ item.note }}</p>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      headers: [
        { text: 'Date', value: 'createdAt' },
        { text: 'Amount', value: 'amount' },
        { text: 'Balance', value: 'spending.total' },
        // { text: 'Update by', value: 'createdBy.email' },
        { text: 'Ref.', value: 'reference' }
        // { text: 'Note', value: 'note' }
      ]
    }
  },
  methods: {
    seeMore (item) {
      this.$router.push({ name: 'MemberDetail', params: { id: item.id } })
    }
  }
}
</script>

<style scoped>
td > p {
  font-size: 12px !important;
  padding: 0px;
  margin: 0px;
}
</style>
